//** NEW TEMPLATE
import React, { useEffect, useState, useCallback, useRef, useDebugValue } from "react";
import { withRouter, Link } from "react-router-dom";
import Routes from "../../Routes";
import { injectIntl } from "react-intl";

// REDUX
import { useSelector, useDispatch } from "react-redux";
import ACTIONS from "../../actions/types";

// HOC
import NewAppHOC from "../../hoc/NewAppHOC";

// FUNCTIONS
import AJAX from "../../functions/ajax";
import S from "../../functions/select";
import validateData from "../../functions/validateData";

// GLOBALS
import GLOBALS from "../../globals/index";

// COMPONENTS
import MainAsideNav from "../../components/navigations/MainAsideNav";
import HelperAsideNav from "../../components/navigations/HelperAsideNav";
import ListNav from "../../components/navigations/ListNav";
import CarouselNav from "../../components/navigations/CarouselNav";
import Main from "../../components/main/Main";
import DisplayScore from "../../components/display/DisplayScore";
import TogglePrompt from "../../components/prompt/TogglePrompt";
import Overview from "../../components/display/Overview";
import NewButton from "../../components/buttons/NewButton";
import AnimateLayout from "../../components/layout/AnimateLayout";
import Title from "../../components/text/Title";
import FormioForm from "../../components/forms/FormioForm";
import Layout from "../../components/layout/Layout";
import Icon from "../../components/icons/Icon";
import ColorAlerter from "../../components/alerts/ColorAlerter";

// DATA MODEL
import caseDataModel from "../../data_model/reviewer/case/case_data";
import ContentAccordion from "../../components/display/ContentAccordion";

function Case({ match, info, intl }) {
  const isInitialMount = useRef(false);
  const isSwitchingCase = useRef(false);
  const _id = 789028790372970;
  let scrollTimeout;
  const dispatch = useDispatch();
  const displayScore = useRef();
  let asideMenuContent = null;
  let displayScoreWidth = null;

  const [counterData, setCounterData] = useState();
  const [activeCase, setActiveCase] = useState(null);
  const [isCounterDone, setIsCounterDone] = useState(false);
  const [isSelfExcluded, setIsSelfExcluded] = useState();
  const [isAdminExcluded, setIsAdminExcluded] = useState();
  const [savedStatus, setSavedStatus] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isLoadingCase, setIsLoadingCase] = useState(false);
  const reduxState = useSelector(state => state);
  const reviewer = useSelector(state => state.reviewer);
  const sizeOfTheScreen = useSelector(state => state.app.sizeOfTheScreen);

  // on route change
  useEffect(() => {
    if (isInitialMount.current) {
      // keep the current case on screen (dimmed) until the next one is loaded
      setIsLoadingCase(true);
      isSwitchingCase.current = true;
      setSavedStatus(false);
      GLOBALS.caseNavMounted = false;
      getMainData();
    } else {
      isInitialMount.current = true;
    }

    let scoreCon = document.getElementById("483864876597484");
    if (scoreCon) {
      unfixTopEl(scoreCon);
    }
  }, [match]);

  // on unmount
  useEffect(() => {
    return () => {
      dispatch({ type: ACTIONS.SET_HELPER_NAV_AS_NOT_PRESENT });
    };
  }, []);

  const getMainData = (preserveForm = false) => {
    // Skip data fetch if currently saving to prevent race conditions
    if (isSaving && preserveForm) {
      return;
    }

    AJAX()
      .getReviewCase(_id, reduxState, Routes.getData().activeUrlLastParam)
      .then(res => {
        // ignore responses for a case the reviewer already navigated away from
        if (res?.data?.case?.id !== Routes.getData().activeUrlLastParam) return;

        const isDataValid = validateData(
          "Reviewer > Case > AJAX().getReviewCase",
          res,
          caseDataModel
        );

        if (isDataValid) {
          const activeCaseData = res.data.case;

          setActiveCase(prevCase => {
            if (preserveForm && prevCase?.form) {
              // When preserving form, merge the new data but keep the current form content
              return {
                ...activeCaseData,
                form: {
                  ...activeCaseData.form,
                  content: {
                    ...activeCaseData.form.content,
                    ...prevCase.form.content, // Preserve current form content, overriding server data
                  },
                },
              };
            }
            return activeCaseData;
          });

          setIsSelfExcluded(activeCaseData.self_excluded);
          setIsAdminExcluded(activeCaseData.admin_excluded);

          // set after the new case so the old one never shows undimmed
          setIsLoadingCase(false);

          // start the next case at its first question and the top of the submission
          if (isSwitchingCase.current) {
            isSwitchingCase.current = false;
            const asideScroller = document.querySelector('[data-name="MainAsideNav"] .__n');
            if (asideScroller) asideScroller.scrollTo(0, 0);
            window.scrollTo(0, 0);
          }

          dispatch({
            type: ACTIONS.SET_PAGE_IDS,
            payload: { stage: activeCaseData.stage_id, collection: activeCaseData.collection_id },
          });

          setCounterData({
            active: activeCaseData.in_range == 0 ? true : false,
            end_at: activeCaseData.end_at,
            start_at: activeCaseData.start_at,
            toWhat: intl.formatMessage({ id: "end" }),
          });
        }
      });
  };

  const toggleAllCases = () => {
    if (sizeOfTheScreen && sizeOfTheScreen === "desktop") {
      dispatch({ type: ACTIONS.TOGGLE_HELLPER_SIDE_NAV });
    }

    if (sizeOfTheScreen && sizeOfTheScreen === "mobile") {
      dispatch({ type: ACTIONS.SHOW_HELPER_NAV_ON_TOP });
      dispatch({ type: ACTIONS.HIDE_MAIN_MENU_ON_TOP });
    }
  };

  const toggleHelperNav = e => {
    if (e.key === "Enter") {
      if (!reduxState.app.helperSideNavToggle) {
        setTimeout(() => {
          S("#btn-390481094")[0].focus();
        }, 200);
      }
    }
  };

  const handleExcludion = () => {
    AJAX()
      .patch(_id, activeCase.apis.toggle_x.api.url, {})
      .then(res => {
        if (res.data.result.self_excluded) {
          setIsSelfExcluded(true);
        } else if (!res.data.result.self_excluded) {
          setIsSelfExcluded(false);
        }
        getMainData();
      })
      .catch(err => console.log(err));
  };

  const handleFormChange = res => {
    setSavedStatus("saving");
    setIsSaving(true);
  };

  const handleFormSave = res => {
    // on form submit
    setSavedStatus("saved");
    setIsSaving(false);

    // Update the active case with the saved data immediately
    if (res && res.data && activeCase) {
      setActiveCase(prevCase => ({
        ...prevCase,
        form: {
          ...prevCase.form,
          content: res.data.data || prevCase.form.content,
        },
        // Update score if it's returned in the response
        score: res.data.score !== undefined ? res.data.score : prevCase.score,
      }));
    }

    // Reload data immediately after save
    // Don't preserve form since we want fresh data from server
    getMainData(false);
  };

  const handleNavItemClick = () => {
    dispatch({ type: ACTIONS.HIDE_HELPER_NAV_ON_TOP });
  };

  const handleCaroselClick = () => {
    // scroll active manu item into the view
    scrollTimeout = setTimeout(() => {
      const activItem = document.querySelector(".listNav_active");
      if (activItem) activItem.scrollIntoView();
    }, 300);
  };

  const handleCounterEnd = () => {
    setIsCounterDone(true);
  };

  const handleScroll = e => {
    const displayScoreCon = document.getElementById("displayScoreCon_12390u13");

    if (!asideMenuContent) {
      displayScore.current = document.getElementById("483864876597484");
      asideMenuContent = document.getElementById("__n_6789689687698");
    } else {
      const asideMenuContentInfo = asideMenuContent.getBoundingClientRect();

      if (asideMenuContentInfo.top + 70 <= 0) {
        if (displayScoreWidth === null) {
          displayScoreWidth = displayScore.current.getBoundingClientRect().width;
        }
        fixToTop(displayScore.current, displayScoreWidth);
        if (displayScoreCon) displayScoreCon.style.height = "3.7rem";
      } else {
        unfixTopEl(displayScore.current);
        if (displayScoreCon) displayScoreCon.style.height = "unset";
      }
    }
  };

  const fixToTop = (el, elWidth) => {
    el.style.width = `${elWidth}px`;
    el.style.position = "fixed";
    el.style.top = "6rem";
    el.style.zIndex = "3";
  };

  const unfixTopEl = el => {
    el.style.width = "unset";
    el.style.position = "unset";
    el.style.top = "unset";
    el.style.zIndex = "unset";
  };

  // ON UNMOUNT
  useEffect(() => {
    return () => {
      dispatch({ type: ACTIONS.HIDE_HELLPER_SIDE_NAV });
      GLOBALS.caseNavMounted = false;
      clearTimeout(scrollTimeout);
    };
  }, []);

  const init = useCallback(() => {
    dispatch({ type: ACTIONS.SET_HELPER_NAV_AS_PRESENT });
    getMainData();
  }, [getMainData]);

  // run once on page load
  useEffect(init, []);

  const { score, overview, top_cases, form, nav, max_restricted_cases, voting_availability } =
    activeCase || {};

  const loadingStyle = {
    transition: "opacity .15s",
    ...(isLoadingCase && { opacity: 0.4, pointerEvents: "none" }),
  };

  return (
    <NewAppHOC>
      <MainAsideNav onScroll={handleScroll}>
        {activeCase && (
          // <AnimateLayout animate={activeCase} addClass="__n_bs" id="__n_6789689687698">
          <div className="__n_bs" id="__n_6789689687698">
            <Link to="/ui/reviewer/dashboard">
              <Layout flex>
                <div>
                  <Icon
                    iconId="reviewCaseFull"
                    addClass="c1 __n_bi"
                    style={{ marginRight: ".7rem" }}
                  />
                </div>
                <Title tagName="h1" addClass="c16" removeWeight>
                  {intl.formatMessage({ id: "reviewerDashboard" })}
                </Title>
              </Layout>
            </Link>
            <div>
              <Link to={`/ui/reviewer/stage/${activeCase.stage_id}`}>
                <Layout flex>
                  <div>
                    <Icon iconId="categoriesFull" addClass="c1 __n_bi" />
                  </div>
                  <Title tagName="span" removeWeight addClass="c16">
                    {activeCase.breadcrumbs.stage.title}
                  </Title>
                </Layout>
              </Link>
              <Link to={`/ui/reviewer/collection/${activeCase.collection_id}`}>
                <Layout flex>
                  <div>
                    <Icon iconId="listFull" addClass="c1 __n_bi" />
                  </div>
                  <Title tagName="span" removeWeight addClass="c16">
                    {activeCase.breadcrumbs.collection.title}
                  </Title>
                </Layout>
              </Link>
            </div>

            {!isSelfExcluded && !isAdminExcluded && (
              <div id="displayScoreCon_12390u13">
                <DisplayScore
                  id="483864876597484"
                  addClass="c10 bc1"
                  style={{ marginTop: "6.5rem" }}
                  score={activeCase.score}
                  savedStatus={savedStatus}
                  confirmed={activeCase.confirmed}
                />
              </div>
            )}
            {!isCounterDone && !isAdminExcluded && activeCase.show_exclude_button !== false && (
              <TogglePrompt
                msg={[
                  intl.formatMessage({ id: "ifBiasedClick" }) !== "&nbsp"
                    ? intl.formatMessage({ id: "ifBiasedClick" })
                    : "",
                  intl.formatMessage({ id: "revertExclude" }),
                ]}
                btnText={[
                  intl.formatMessage({ id: "biased" }),
                  intl.formatMessage({ id: "includeMe" }),
                ]}
                view={isSelfExcluded}
                callback={handleExcludion}
              />
            )}

            {isAdminExcluded && (
              <ColorAlerter warning={true} toggle={true} intlMsg="adminExcludedMsg" />
            )}

            {/* keyed per case: remounts the form and replays the "new case" animation */}
            <div key={activeCase.id} className={`__cs ${isLoadingCase ? "__cs--loading" : ""}`}>
              {isLoadingCase && (
                <div className="__cs_spinner">
                  <div className="__l" />
                </div>
              )}
              {!isSelfExcluded && !isAdminExcluded && form && (
                <FormioForm
                  formData={form}
                  votingAvailability={voting_availability}
                  options={info.default_formio_options}
                  blockFormSubmission={isCounterDone || activeCase.in_range == 0 ? false : true}
                  onChange={handleFormChange}
                  onSave={handleFormSave}
                  intl={intl}
                />
              )}
            </div>

            {activeCase.coll_stats.stats.todo === 0 &&
              !activeCase.coll_stats.confirmed &&
              reviewer && (
                <TogglePrompt
                  confirmer
                  title={[intl.formatMessage({ id: "almostDone" }), ""]}
                  msg={[intl.formatMessage({ id: "allFinished" }), ""]}
                  url={`${Routes.reviewerCollection().path}/${reviewer.collection}`}
                  btnText={[intl.formatMessage({ id: "reviewVotes" }), ""]}
                  iconID={"celebrate"}
                />
              )}
            {activeCase.coll_stats.stats.todo === 0 && activeCase.coll_stats.confirmed && (
              <TogglePrompt
                confirmer
                title={[intl.formatMessage({ id: "collectionFinished" }), ""]}
                msg={[intl.formatMessage({ id: "allProjectsCollectionFinished" }), ""]}
                iconID={"celebrate"}
              />
            )}
            {nav && <CarouselNav data={nav} onBtnClick={handleCaroselClick} />}
            {activeCase.show_all_projects !== false && (
              <NewButton
                id="btn-19004981"
                onClick={toggleAllCases}
                onKeyDown={toggleHelperNav}
                btnStyle="flat"
                colStyle="gray"
                style={{
                  width: "100%",
                  textTransform: "uppercase",
                  fontWeight: "bold",
                  display: "inline-block",
                }}
                value={
                  reduxState.app.helperSideNavToggle
                    ? intl.formatMessage({ id: "hideAllProjects" })
                    : intl.formatMessage({ id: "showAllProjects" })
                }
              />
            )}

            {activeCase.show_selected_projects !== false &&
              max_restricted_cases &&
              max_restricted_cases.length > 0 && (
                <ListNav
                  type="selected_cases"
                  title={intl.formatMessage({ id: "selectedProjects" })}
                  linkTo={Routes.reviewerCase().path}
                  list={max_restricted_cases}
                />
              )}

            {activeCase.show_top_projects !== false && top_cases.length > 0 && (
              <ListNav
                type="rating"
                title={intl.formatMessage({ id: "topProjects" })}
                linkTo={Routes.reviewerCase().path}
                list={top_cases}
              />
            )}
          </div>
          // </AnimateLayout>
        )}
      </MainAsideNav>
      <Main counter={counterData} onCounterEnd={handleCounterEnd}>
        {overview && (
          // <AnimateLayout animate={overview}>
          <div style={loadingStyle}>
            {overview.additional_content && (
              <ContentAccordion
                firstContent={overview.additional_content.collapsed_content}
                secondContent={overview.additional_content.content}
              />
            )}
            <Overview overviewData={overview} readonly={true} />
          </div>
          // </AnimateLayout>
        )}
      </Main>
      <HelperAsideNav>
        {nav && (
          <ListNav
            clicked={handleNavItemClick}
            title={intl.formatMessage({ id: "allProjectsCollection" })}
            linkTo={Routes.reviewerCase().path}
            type="cases"
            list={nav.cases || []}
          />
        )}
      </HelperAsideNav>
    </NewAppHOC>
  );
}

export default injectIntl(withRouter(Case));
